//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from '../../configs';
/*
|---------------------------------------------------------------------
| Toolbar Apps Component
|---------------------------------------------------------------------
|
| Quickmenu for applications in the toolbar
|
*/
export default {
  data: function data() {
    return {
      apps: config.toolbar.apps
    };
  },
  methods: {
    navigateTo: function navigateTo(path) {
      if (this.$route.path !== path) this.$router.push(path);
    }
  }
};